import styles from './watchlist-modal.module.scss'
import ModalWTN from 'components/generic/ModalWTN'
import { useModalDispatch } from 'hooks/use-modal'
import { WatchlistsModalId, WatchlistsModalsState } from 'constants/modals'
import WatchlistNameField, { useWatchlistNameField } from '../common/WatchlistNameField'
import { useDispatch, useSelector } from 'react-redux'
import { addWatchlist, setDestinationWatchlistIds } from 'actions/watchlist-actions'
import { AppState } from 'redux/reducers'
import useWindowSize from 'hooks/use-windowSize'
import { TABLET_BREAKPOINT } from 'constants/global'
import { MAX_WATCHLISTS_LENGTH } from 'constants/watchlists'
import cx from 'classnames'
import { useTranslation } from 'react-i18next'

const CreateWatchlistModal = () => {
  const { t: tWatchlists } = useTranslation('strWatchlists')
  const { t: tCommonUI } = useTranslation('strCommonUI')
  const dispatch = useDispatch()
  const watchlists = useSelector((state: AppState) => state.watchlists.watchlists)
  const existingWatchlistsNames = Object.values(watchlists).map(w => w.name)
  const isFull = existingWatchlistsNames.length >= MAX_WATCHLISTS_LENGTH
  const { value, setValue, validate, clearError, props } = useWatchlistNameField({
    forbiddenNames: existingWatchlistsNames,
  })
  const { modalDispatch, modalActions } = useModalDispatch<
    WatchlistsModalsState,
    WatchlistsModalId.CREATE_WATCHLIST
  >(WatchlistsModalId.CREATE_WATCHLIST)
  const windowWidth = useWindowSize().width
  const isMobile = windowWidth < TABLET_BREAKPOINT

  const resetState = () => {
    setValue('')
    clearError()
  }

  const handleCancel = () => {
    modalDispatch(modalActions.closeModal())
    resetState()
  }

  const handleConfirm = () => {
    const error = validate(value)
    if (!error) {
      modalDispatch(modalActions.closeModal())
      dispatch(addWatchlist({ name: value, personIds: [] }))
      dispatch(setDestinationWatchlistIds([]))
      resetState()
    }
  }

  return (
    <ModalWTN
      className={styles.createModal}
      modalId={WatchlistsModalId.CREATE_WATCHLIST}
      widgetElId='watchlists'
      textHeader={isFull ? tWatchlists('createModal.titleFull') : tWatchlists('createModal.title')}
      reducedHeaderMargin
      btnAlignment='right'
      btnPrimary={
        isFull
          ? undefined
          : {
              text: isMobile ? tCommonUI('button.save') : tWatchlists('overview.createBtn'),
              onClick: handleConfirm,
            }
      }
      btnSecondary={{
        text: isFull ? tCommonUI('button.close') : tCommonUI('button.cancel'),
        onClick: handleCancel,
      }}
      onAfterClose={resetState}
    >
      {isFull ? (
        <p className={cx(styles.infoFull)}>{tWatchlists('createModal.infoFull')}</p>
      ) : (
        <>
          <p className={styles.info}>{tWatchlists('createModal.info')}</p>
          <WatchlistNameField {...props} />
        </>
      )}
    </ModalWTN>
  )
}

export default CreateWatchlistModal
